import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	width: 100%;
	min-width: 400px;
	display: flex;
	flex-direction: column;
	gap: 1rem;
	align-items: flex-start;
	justify-content: center;
`;

export const list = styled.div`
	width: 100%;
	height: 200px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: flex-start;
	gap: 0.5rem;
	overflow: auto;
	border: 1px solid ${color.interface.lightGray2};
	border-radius: 5px;
	padding: 0.5rem;
`;

export const itemList = styled.div`
	width: 100%;
	display: flex;
	align-items: flex-start;
	justify-content: center;
	gap: 0.5rem;
	padding: 0.5rem;
	background-color: ${color.interface.lightGray4};
	border-radius: 5px;
`;

export const infos = styled.div`
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	gap: 1rem;
	padding: 0.5rem;
`;

export const controls = styled.div`
	width: fit-content;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 1rem;

	> svg {
		cursor: pointer;
		color: ${color.interface.darkgray};
		font-size: 2.5rem;
	}
`;

export const noData = styled.div`
	width: 100%;
	height: 200px;
	display: flex;
	align-items: center;
	justify-content: center;
	border: 1px solid ${color.interface.lightGray2};
	border-radius: 5px;

	> p {
		font-size: 1.4rem;
	}
`;

export const form = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	gap: 1rem;
	align-items: center;
	justify-content: center;
`;

export const containerBtns = styled.div`
	width: 100%;
	margin-top: 1rem;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	gap: 1rem;

	> button {
		all: unset;
		width: 100%;
		text-align: center;
		border-radius: 5px;
		padding: 1rem 2rem;
		color: ${color.interface.white};
		font-size: 1.3rem;
		cursor: pointer;
	}
`;

export const save = styled.button`
	background-color: ${color.system.success} !important;
`;

export const cancel = styled.button`
	background-color: ${color.system.error} !important;
`;
